// Read the dca_ref cookie set by App.js when ?ref=CODE was in the URL.
// Returns '' when no cookie is present.
export function getReferralCode() {
  if (typeof document === 'undefined' || !document.cookie) return '';
  const m = document.cookie.match(/(?:^|; )dca_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}
